import { useExperiencesContext } from '../../../experiences/Experiences';
import {
  useFacetContext,
  useProductContext,
} from '../../../../context/PlpContext';
import { usePlpViewType } from '../../../../hooks/usePlpViewType';

type ControlsData = {
  experiences: {
    isHideTopPaginationFlagOn: boolean;
    isListViewEnabled: boolean;
    isProductCardSizeFlagOn: boolean;
    isReplaceTopPaginationFlagOn: boolean;
    isTabletEnhancementsFlagOn: boolean;
    isSingleColumnLayout: boolean;
  };
  facetContext: {
    baseFacetId: string;
    isMoreFiltersButton: boolean;
    applied: {
      filterCombination: string;
    };
  };
  plpViewType: {
    hasPlpViewTypeSelection: boolean;
  };
  productContext: {
    totalNumberOfResults: number;
  };
};

export const useControlsData = (): ControlsData => {
  const {
    isHideTopPaginationFlagOn,
    isListViewEnabled,
    isProductCardSizeFlagOn,
    isReplaceTopPaginationFlagOn,
    isTabletEnhancementsFlagOn,
    isSingleColumnLayout,
  } = useExperiencesContext();

  const {
    baseFacetId,
    isPrimaryFacetInDiscoResponse: isMoreFiltersButton,
    applied,
  } = useFacetContext();

  const { hasPlpViewTypeSelection } = usePlpViewType('useControlsData');

  const { totalNumberOfResults } = useProductContext();

  return {
    experiences: {
      isHideTopPaginationFlagOn,
      isListViewEnabled,
      isReplaceTopPaginationFlagOn,
      isProductCardSizeFlagOn,
      isTabletEnhancementsFlagOn,
      isSingleColumnLayout,
    },
    facetContext: {
      baseFacetId,
      isMoreFiltersButton,
      applied,
    },
    plpViewType: {
      hasPlpViewTypeSelection,
    },
    productContext: {
      totalNumberOfResults,
    },
  };
};
